<div class="wrapper-faq">
    <div class="section-main">
        <h1 class="title text-center">
            <span class="text-blue">Frequently</span>
            Asked Questions

            <img class="yellow-line" src="../../assets/yellow-line.png" alt="line">
        </h1>

    </div>

    <div class="bg-curve">
        <div class="d-flex justify-content-center">
            <button (click)="goToSignUp()" class="btn btn-create rounded-pill">
                Setup New Store
            </button>
        </div>
    </div>

    <div class="section-questions container-xl">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6" *ngFor="let item of createCategory(); let index=index">
          <h3 class="title" *ngIf="records[index]['category'] === 'sign_up' ">{{"General Questions" | translate}}</h3>
          <h3 class="title" *ngIf="records[index]['category'] != 'sign_up' ">{{records[index]['category'] | uppercase}}</h3>
          <div class="section-cards">
            <div class="card card-white mt-3" *ngFor="let subItem of createQuestionAnswer(records[index]['category']); let subIndex=index">
              <div (click)="toggleAnswer(index, subIndex)" class="row card-contents">
                <div class="w-10">
                  <img *ngIf="!answer[index][subIndex]" class="plus-icon" src="../../assets/icon/plus-icon.png" alt="plus">
                  <img *ngIf="answer[index][subIndex]" class="minus-icon" src="../../assets/icon/minus-icon.png" alt="minus">
                </div>
                <div class="w-90">
                  <p [className]="!answer[index][subIndex] ? 'card-text' : 'card-text-blue'">{{records[index]['qa'][subIndex][0]}}</p>
                </div>
                <div [@collapse]="!answer[index][subIndex]" class="section-info">
                  <p class="card-info">
                    {{records[index]['qa'][subIndex][1]}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="section-inspire container-xl">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-5 image-container">
                <img class="person-image" src="../../assets/person.png" alt="person">
            </div>
            <div class="col-12 col-sm-12 col-md-7 text-container">
                <h3 class="subtitle">Be inspired & become an inspiration to others</h3>
                <h1 class="title">1,330,889,000</h1>
                <p class="info">Our dealers are conquering the world e-Commerce market</p>
            </div>
        </div>
    </div>

    <div class="section-cta container-xl">
        <div class="card">
            <div class="section-top">
                <img class="ellipse-yellow" src="../../assets/ellipse-yellow.png" alt="yellow">
            </div>
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                    <h4 class="card-title">ESTORE - Make You Possible</h4>
                    <p class="card-subtitle">You’re not only designing your eStore, but also your future!</p>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 section-btn">
                    <button (click)="goToSignUp()" class="btn btn-create rounded-pill mb-20">
                        Setup New Store
                    </button>
                </div>
            </div>
            <div class="section-bottom">
                <img class="ellipse-blue" src="../../assets/ellipse-blue.png" alt="blue">
            </div>
        </div>
    </div>
</div>
